var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5C7.46243 5 5 7.46243 5 10.5C5 13.5376 7.46243 16 10.5 16C13.5376 16 16 13.5376 16 10.5C16 7.46243 13.5376 5 10.5 5ZM3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5C18 11.9752 17.5741 13.3509 16.8386 14.5109C16.6373 14.8282 16.6617 15.2475 16.9274 15.5132L20.1768 18.7626C20.4697 19.0555 20.4697 19.5303 20.1768 19.8232L19.8232 20.1768C19.5303 20.4697 19.0555 20.4697 18.7626 20.1768L15.5132 16.9274C15.2475 16.6617 14.8282 16.6373 14.5109 16.8386C13.3509 17.5741 11.9752 18 10.5 18C6.35786 18 3 14.6421 3 10.5Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsearch);
export default __webpack_public_path__ + "static/media/icon.search.a9effc33edd8e6779d43a116de9b14a3.svg";
export { ForwardRef as ReactComponent };